import { Text, View } from "react-native";
import { MoonDivider } from "./MoonDivider";

export type AuthDividerProps = {
  label: string;
};

/**
 * The shared separator between phone authentication and alternate methods.
 * The label is supplied by the caller so the primitive stays locale-agnostic.
 */
export function AuthDivider({ label }: AuthDividerProps) {
  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        marginVertical: 20,
      }}
    >
      <MoonDivider color="rgba(255, 255, 255, 0.14)" style={{ flex: 1 }} />
      <Text
        style={{
          fontSize: 11,
          fontWeight: "500",
          letterSpacing: 1.2,
          color: "rgba(255, 255, 255, 0.58)",
          textTransform: "uppercase",
          marginHorizontal: 14,
        }}
      >
        {label}
      </Text>
      <MoonDivider color="rgba(255, 255, 255, 0.14)" style={{ flex: 1 }} />
    </View>
  );
}
